import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=42bb2365&scoped=true&"
import script from "./ProfileForm.vue?vue&type=script&lang=js&"
export * from "./ProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=42bb2365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb2365",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bb2365')) {
      api.createRecord('42bb2365', component.options)
    } else {
      api.reload('42bb2365', component.options)
    }
    module.hot.accept("./ProfileForm.vue?vue&type=template&id=42bb2365&scoped=true&", function () {
      api.rerender('42bb2365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/ProfileForm.vue"
export default component.exports